import React, { useEffect } from 'react';
import { useLocation } from 'react-router';
import { Route, Switch } from 'react-router-dom';
import { getRouteStackPath } from '@portal/config/routes';
import PanelContent from '~/components/PanelContent/PanelContent';
import { sendEvent } from '@portal/services/firebase';
import { PageClass } from '@portal/enum/analytics';
import UserManagerMenus from './UserManagerMenus/UserManagerMenus';
import UserManagerList from './UserManagerList/UserManagerList';
import CreateUserManager from './CreateUserManager/CreateUserManager';

const UserManagerNavigationStack = () => {
  const location = useLocation();

  useEffect(() => {
    sendEvent('page_view', {
      firebase_page: location.pathname,
      firebase_page_class: PageClass.MANAGER_USER,
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  return (
    <Switch>
      <Route exact path={getRouteStackPath('USER_MANAGER', 'USER_MANAGER')}>
        <PanelContent pageTitle="Operadores">
          <UserManagerMenus />
        </PanelContent>
      </Route>

      <Route exact path={getRouteStackPath('USER_MANAGER', 'USER_LIST')}>
        <PanelContent pageTitle="Operadores">
          <UserManagerList />
        </PanelContent>
      </Route>

      <Route exact path={getRouteStackPath('USER_MANAGER', 'NEW_USER')}>
        <PanelContent pageTitle="Cadastro">
          <CreateUserManager />
        </PanelContent>
      </Route>
    </Switch>
  );
};

export default UserManagerNavigationStack;
